
import {
  Status
} from '@/common/enumerations';
import { EventBus } from '@/event-bus';
import {
  Client,
  IJobItemActivityModel,
  IJobItemModel,
  IJobItemScheduleModel
} from '@/services/api.service';
import {
  JobItemScheduleUpdatedMessage,
  JobItemStatusChangedMessage,
  JobItemUpdatedMessage
} from '@/services/eventbus.models';
import { Component, Vue, Watch } from 'vue-property-decorator';
import JobItemEdit from '../processes/JobItemEdit.vue';

import toJobItemTypeFormatter from '@/filters/jobitemtype.formatter';
import toStatusFormatter from '@/filters/status.formatter';
import toDateFormatter from '@/filters/todate.formatter';

enum JobInvoiceState {
  None = 0,
  Pending = 1,
  AllInvoiced = 2
}

@Component({
  components: {
    JobItemEdit
  },
  props: {
    jobItem: {
      type: Object as () => IJobItemModel,
      required: false
    },
    activities: {
      type: Array as () => IJobItemActivityModel[],
      required: false
    },
    jobGid: String,
    jobNumber: String
  },
  filters: {
    toJobItemType: toJobItemTypeFormatter,
    toStatus: toStatusFormatter,
    toDate: toDateFormatter
  }
})
export default class JobItemListRow extends Vue {
  private schedule: IJobItemScheduleModel | null = null;
  private status: Status = Status.Pending;
  private hasCurrentSchedule: boolean = false;
  private loadingSchedule: boolean = false;

  protected created() {
    EventBus.$on('job-item-scheduled', (message: JobItemScheduleUpdatedMessage) => {
      this.handleJobItemScheduledEvent(message);
    });
    EventBus.$on('job-item-status-changed', (message: JobItemStatusChangedMessage) => {
      this.handleJobItemStatusChangedEvent(message);
    });
    EventBus.$on('job-item-updated', (message: JobItemUpdatedMessage) => {
      this.handleJobItemUpdatedEvent(message);
    });
  }

  protected mounted() {
    // get the networks
    // Object.assign(this.data, this.$props.jobItem);
    // console.log('JobItemCard:localdatamodel');
    // console.log(this.data);
    this.status = (this.$props.jobItem.status as any) as Status;
    //this.fetchCurrentSchedule(this.$props.jobGid, this.$props.jobItem.gid);
    console.log('Activities for ' + this.$props.jobItem.name, this.$props.activities);
  }
  protected beforeDestroy() {
    EventBus.$off('job-item-scheduled');
    EventBus.$off('job-item-status-changed');
    EventBus.$off('job-item-updated');
  }
  private get hasActivityPendingInvoicing(): boolean {
    return this.currentInvoiceState === JobInvoiceState.Pending;
  }
  private get hasActivityFullyInvoiced(): boolean {
    return this.currentInvoiceState === JobInvoiceState.AllInvoiced;
  }
  private get currentInvoiceState(): JobInvoiceState {
    if (this.$props.activities && this.$props.activities.length > 0) {
      const invoiced = this.$props.activities.filter((a: IJobItemActivityModel) => a.isInvoiced && a.invoiceType === 0);

      if (invoiced && invoiced.length === this.$props.activities.length) {
        // all are invoiced
        return JobInvoiceState.AllInvoiced;
      }
      if (this.$props.activities.some((a: IJobItemActivityModel) => !a.isInvoiced && a.invoiceType === 0)) {
        return JobInvoiceState.Pending;
      }

    }
    return JobInvoiceState.None;
  }

  @Watch('jobItem', { immediate: false, deep: true })
  private onjobItemChanged(oldValue: IJobItemModel, newValue: IJobItemModel) {
    console.log('watched job item changed:');
    console.log(oldValue);
    console.log(newValue);
  }

  private handleJobItemScheduledEvent(message: JobItemScheduleUpdatedMessage) {
    console.log('EVENTBUS: received job-item-scheduled message');
    console.log(message);

    if (message.jobItemGid === this.$props.jobItem.gid) {
      // Got a new schedule for the job item card
      if (message.data !== null) {
        //this.updateScheduleModel(message.data);
        // Update the job item scheduleDate property, not worrying
        // about the rest of the schedule data for the moment.
        this.$props.jobItem.scheduledDate = message.data.scheduledDate;
      }
    }
  }

  private handleJobItemStatusChangedEvent(message: JobItemStatusChangedMessage) {
    console.log('EVENTBUS: received job-item-status-changed message');
    console.log(message);
    if (message.data !== null) {
      if (message.data.gid === this.$props.jobItem.gid) {
        // Got a new schedule for the job item card
        this.status = message.newStatus; // as any as JobItemModelStatus;
      }
    }
  }

  private handleJobItemUpdatedEvent(message: JobItemUpdatedMessage) {
    console.log('EVENTBUS: received job-item-updated message');
    console.log(message);
    if (message.data !== null) {
      if (message.data.gid === this.$props.jobItem.gid) {
        // Just update the status for the moment. The rest
        // of the property changes are pushed in via the
        // $props.jobItem
        this.status = (message.data.status as any) as Status;
      }
    }
  }

  private async fetchCurrentSchedule(jobgid: string, jobItemGid: string) {
    this.loadingSchedule = true;
    const clientService = new Client(process.env.VUE_APP_API_URL, this.$http);
    const [theJobItemSchedule] = await Promise.all([
      clientService.getCurrentJobItemSchedule(jobgid, jobItemGid)
    ]);

    if (theJobItemSchedule !== null) {
      this.updateScheduleModel(theJobItemSchedule);
    }
    this.loadingSchedule = false;
  }

  private updateScheduleModel(data: IJobItemScheduleModel) {
    this.schedule = data;
    this.hasCurrentSchedule = true;
  }

  private editJobItem() {
    this.$emit('on-edit-jobitem', this.$props.jobItem);
  }

  private addJobItemActivity() {
    this.$emit('on-add-jobitem-activity', this.$props.jobItem);
  }
  private scheduleJobItem() {
    this.$emit('on-schedule-jobitem', this.$props.jobItem);
  }
  private createInvoice() {
    this.$emit('on-create-jobitem-invoice', this.$props.jobItem);
  }

  private transitionJobItem() {
    this.$emit('on-transition-jobitem', this.$props.jobItem);
  }

  private repeatJobItem() {
    this.$emit('on-repeat-jobitem', this.$props.jobItem);
  }

  private getStatus(value: number) {
    return toStatusFormatter(value).toLowerCase();
  }
}
